export default __webpack_public_path__ + "static/social-logo-90c5da84fcf6a495d55de7ecd0d44533.png";